import React from "react";

import {Breadcrumb, Button, Card, Col, Form, Steps} from 'antd';
import useController from "./CreateUpdateLicenceDialog.controller";
import StyledContainer from "./CreateUpdateLicenceDialog.style";
import {Link, withRouter} from "react-router-dom";
import LeftOutlined from "@ant-design/icons/es/icons/LeftOutlined";
import FirstStepChooseCompanyAndProduct from "./components/FirstStepChooseCompanyAndProduct";
import SecondStepElements from "./components/SecondStepElements";
import ThirdStepConfirmation from "./components/ThirdStepConfirmation";
import CompanyLicenceSuccessDialog from "./components/CompanyLicenceSuccessDialog";
import {clearNewlyAddedLicence} from "../../redux/actions/addLicenceActions";

const CreateUpdateLicenceDialog = ({location: {pathname}, history}) => {

    const {
        current, next, prev, onChange,
        onCompanyChange, companySelected,
        newLicence,
        addAnotherLicence,
        goToLicences,
        licenceForm, companyHasSoftwareProduct, availableSoftwareProductElements, companyPreviouslyAddedProducts, availableCompanies, availableSoftwareProducts, availableExpiryActions,
        onProductsChange, isDeviceSmall, isDeviceMedium, addLicenceElement, removeLicenceElement, submitLicence, initialValues, licenceElements, licenceSavePending, darkMode, primaryColor
    } = useController({
        pathname,
        history
    });

    const {Step} = Steps;

    const steps = [
        {
            step: 0,
            title: 'Licence',
            description: 'Select company and product',
            content: FirstStepChooseCompanyAndProduct({
                onCompanyChange, companySelected,
                licenceSavePending,
                availableCompanies,
                availableSoftwareProducts,
                companyPreviouslyAddedProducts,
                companyHasSoftwareProduct,
                licenceElements,
                onProductsChange,
                darkMode
            }),
        },
        {
            step: 1,
            title: 'Licence Elements',
            description: 'Choose licence elements',
            content: SecondStepElements(({
                licenceSavePending,
                availableSoftwareProductElements,
                availableExpiryActions,
                addLicenceElement,
                removeLicenceElement,
                licenceElements,
                darkMode,
                isDeviceMedium,
                isDeviceSmall,
                primaryColor
            })),
        },
        {
            step: 2,
            title: 'Confirmation',
            description: 'Confirm Licence creation',
            content: ThirdStepConfirmation(({
                licenceForm,
                availableCompanies,
                availableSoftwareProducts,
                licenceElements,
                isDeviceSmall,
                primaryColor,
                darkMode
            })),
        }
    ];

    const layout = {
        labelCol: {span: 8},
        wrapperCol: {span: 16},
    };

    const stepsProperties = isDeviceSmall ? {direction: 'vertical', size: 'small'} : {};

    return (
        <StyledContainer primaryColor={primaryColor}>

            <Breadcrumb>
                <Breadcrumb.Item><Link to={'/licence'}><LeftOutlined/> Back to Licences</Link></Breadcrumb.Item>
            </Breadcrumb>
            <Card title='Add New Licence'>
                {
                    newLicence ?
                        <CompanyLicenceSuccessDialog clearNewlyAddedLicence={clearNewlyAddedLicence}
                                                     newLicence={newLicence}
                                                     addAnotherLicence={addAnotherLicence}
                                                     goToLicences={goToLicences}/> :
                        <Form initialValues={initialValues} form={licenceForm} {...layout}>
                            <Steps current={current} {...stepsProperties} onChange={onChange}>
                                {steps.map(item => (
                                    <Step disabled={licenceSavePending} key={item.title} title={item.title}
                                          description={item.description}/>
                                ))}
                            </Steps>


                            {steps.map(({step, content}) =>
                                (<div key={step.toString()} className={`steps-content ${step !== current && "hidden"}`}>
                                    {content}
                                </div>))}

                            <div className="steps-action">
                                <Col offset={8} span={16}>
                                    {current < steps.length - 1 && (
                                        <Button type="primary" onClick={next}>
                                            Next
                                        </Button>
                                    )}
                                    {current === steps.length - 1 && (
                                        <Button loading={licenceSavePending} type="primary" onClick={submitLicence}>
                                            Confirm Licence Activation
                                        </Button>
                                    )}
                                    {current > 0 && (
                                        <Button disabled={licenceSavePending} style={{margin: '0 8px'}} onClick={prev}>
                                            Previous
                                        </Button>
                                    )}
                                </Col>
                            </div>

                        </Form>
                }
            </Card>

        </StyledContainer>
    );
};

export default withRouter(CreateUpdateLicenceDialog);